import { Linkedin, Instagram, Facebook } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#0f0f0f] text-gray-400">
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid gap-12 md:grid-cols-4">

          {/* BRAND */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img
                src="https://cdn.prod.website-files.com/638fda8f8e2f041af84cb5a7/6824d581ae24f69d45e26536_beem%20logo%203.png" // replace with your logo path
                alt="Beem logo"
                className="h-8 w-auto"
              />
            </div>

            <p className="text-sm leading-relaxed max-w-xs">
              The modern property management platform for landlords,
              investors and letting agents.
            </p>

            {/* SOCIALS */}
            <div className="mt-6 flex gap-4">
              <a
                href="https://www.facebook.com/beem.tech"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition"
                aria-label="Beem on Facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://www.linkedin.com/company/beem-tech/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition"
                aria-label="Beem on LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="https://www.instagram.com/beem.network/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition"
                aria-label="Beem on Instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* COMPANY */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              Quick Links
            </h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/sign-in" className="hover:text-white">Tenant Portal</Link></li>
              <li><Link to="/sign-in" className="hover:text-white">Sign In</Link></li>
              <li><Link to="/sign-up" className="hover:text-white">Create an account</Link></li>
            </ul>
          </div>

          {/* LEGAL */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              Legal
            </h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/terms" className="hover:text-white">Terms of Service</Link></li>
              <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/cookies" className="hover:text-white">Cookie Policy</Link></li>
            </ul>
          </div>

        </div>

        {/* BOTTOM BAR */}
        <div className="mt-16 border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-500">
            © {new Date().getFullYear()} Beem Ltd. All rights reserved.
          </p>

          <p className="text-xs text-gray-500">
            Registered in England & Wales · Company No. 16730762
          </p>
        </div>
      </div>
    </footer>
  );
}
